import React from 'react';
import TrashIcon from '@atlaskit/icon/core/migration/delete--trash';
export const getTokenDeltaProps = token => {
  let decodedToken;
  try {
    decodedToken = JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    // why would this be the case
    return {
      tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
      localTimeDelta: undefined,
      tokenExpiryTime: undefined
    };
  }

  // In my testing, sometimes issued at was missing
  const startTimestamp = decodedToken.iat || decodedToken.nbf;
  const getLocalTimeDeltaMilliseconds = startTimestamp => startTimestamp ? startTimestamp - Date.now() : undefined;
  return {
    tokenDecodeError: undefined,
    localTimeDelta: getLocalTimeDeltaMilliseconds(startTimestamp * 1000),
    // @ts-ignore
    tokenExpiryTime: decodedToken.exp * 1000
  };
};
export const transformReadAttachmentsToken = readAttachmentsToken => {
  const getFirstTokenIfAvailable = tokensWithFiles => tokensWithFiles.length > 0 ? tokensWithFiles[0].token : null;
  const token = getFirstTokenIfAvailable(readAttachmentsToken.tokensWithFiles);
  const tokenProps = typeof token === 'string' ? getTokenDeltaProps(token) : {};
  return {
    clientId: readAttachmentsToken.clientId,
    serviceHost: readAttachmentsToken.endpointUrl,
    token,
    areTokenPermissionsUpToDate: true,
    tokenLifespanInMs: readAttachmentsToken.tokenLifespanInSeconds * 1000,
    tokenIssueTimestamp: Date.now() - 10000,
    // added 10s buffer to cover network calls
    collection: null,
    tokenDecodeError: tokenProps.tokenDecodeError,
    localTimeDelta: tokenProps.localTimeDelta,
    tokenExpiryTime: tokenProps.tokenExpiryTime
  };
};
export const transformUploadContext = uploadToken => {
  return {
    clientId: uploadToken.clientId,
    serviceHost: uploadToken.endpointUrl,
    token: uploadToken.token,
    tokenLifespanInMs: uploadToken.tokenDurationInMins * 60 * 1000,
    collection: uploadToken.targetCollection,
    tokenIssueTimestamp: Date.now() - 10000 // added 10s buffer to cover network calls
  };
};
export const transformData = ({
  readToken,
  uploadToken
}) => {
  return {
    viewContext: readToken ? transformReadAttachmentsToken(readToken) : null,
    uploadContext: uploadToken ? transformUploadContext(uploadToken) : null
  };
};
export const formatFilesWithEditActions = (files, mediaClientConfig, collection, removeFile) => {
  const toBeUploadedFiles = [];
  files.forEach(file => {
    toBeUploadedFiles.push({
      identifier: {
        id: file.id,
        mediaItemType: 'file',
        collectionName: collection
      },
      info: {
        ...file
      },
      mediaClientConfig: mediaClientConfig,
      actions: [{
        handler: removeFile,
        icon: /*#__PURE__*/React.createElement(TrashIcon, {
          color: "currentColor",
          spacing: "spacious",
          label: "Delete"
        }),
        label: 'Delete'
      }]
    });
  });
  return toBeUploadedFiles;
};
export const formatFilesWithViewActions = (files, mediaClientConfig, collection) => {
  const toBeUploadedFiles = [];
  files.forEach(file => {
    toBeUploadedFiles.push({
      identifier: {
        id: file.id,
        mediaItemType: 'file',
        collectionName: collection
      },
      info: {
        ...file
      },
      mediaClientConfig: mediaClientConfig,
      actions: []
    });
  });
  return toBeUploadedFiles;
};
export const sortFilesYoungestFirstOnLeft = (a, b) => {
  return b.info.creationDate && a.info.creationDate ? b.info.creationDate - a.info.creationDate : 0;
};